import { createContext, createElement, ReactNode, useMemo, useState } from 'react';

/**
 * Where a list page's title row takes the list's count and its Export in the new design: elements the page header
 * renders (see PageHeader), which the page's list portals into. A list with no header to take them, such as a
 * record's tab, keeps both in its toolbar.
 */
export type ListHeaderSlots = {
    count: HTMLElement | null;
    actions: HTMLElement | null;
    setCount: (element: HTMLElement | null) => void;
    setActions: (element: HTMLElement | null) => void;
};

export const ListHeaderSlotsContext = createContext<ListHeaderSlots | undefined>(undefined);

/** Above the routed page: the page header and its list are siblings, so the slots live here. */
export function ListHeaderSlotsProvider({ children }: { children: ReactNode }) {
    const [count, setCount] = useState<HTMLElement | null>(null);
    const [actions, setActions] = useState<HTMLElement | null>(null);
    const value = useMemo(() => ({ count, actions, setCount, setActions }), [count, actions]);
    return createElement(ListHeaderSlotsContext.Provider, { value }, children);
}
